import type { TimeSource } from "../game/engine";

/** Écart au-delà duquel on se recale d'un coup (veille de l'appareil, horloge système changée). */
const SNAP_MS = 1500;
/** Poids d'une nouvelle mesure ordinaire : les petites variations de latence se lissent. */
const SMOOTHING = 0.2;

/**
 * L'horloge du serveur, estimée : `Date.now()` plus un décalage mesuré sur chaque réponse qui porte
 * l'heure du serveur (au milieu de l'aller-retour). `Date.now()` continue pendant la veille de l'appareil,
 * ce qui permet de voir le temps passé ; ses sauts éventuels sont rattrapés à la réponse suivante.
 */
export class ServerClock implements TimeSource {
  private offset = 0;
  private calibrated = false;

  constructor(private readonly local: () => number = () => Date.now()) {}

  now(): number {
    return this.local() + this.offset;
  }

  get isCalibrated(): boolean {
    return this.calibrated;
  }

  /** Une réponse du serveur : son heure, et nos instants d'envoi et de réception. */
  sample(serverTime: string, sentAt: number, receivedAt: number): void {
    const server = Date.parse(serverTime);
    if (!Number.isFinite(server) || receivedAt < sentAt) return;
    const measured = server - (sentAt + receivedAt) / 2;
    if (!this.calibrated || Math.abs(measured - this.offset) > SNAP_MS) {
      this.offset = measured;
      this.calibrated = true;
      return;
    }
    this.offset += (measured - this.offset) * SMOOTHING;
  }
}
